import SelectChallengeBlockTable from './SelectChallengeBlockTable';

export default SelectChallengeBlockTable;
